/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { RoseCollection, RoseCollectionInterface } from '../RoseCollection'

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: '_name',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string',
      },
      {
        internalType: 'string',
        name: '_url',
        type: 'string',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Locked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'MinterAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'MinterRemoved',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]',
      },
    ],
    name: 'TransferBatch',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'TransferSingle',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'URI',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    name: 'Unlocked',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'WhitelistAdminAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'WhitelistAdminRemoved',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'addMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'addWhitelistAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'burn',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]',
      },
    ],
    name: 'burnBatch',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_maxSupply',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_initialSupply',
        type: 'uint256',
      },
      {
        internalType: 'string',
        name: '_uri',
        type: 'string',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'create',
    outputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_maxSupply',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_initialSupply',
        type: 'uint256',
      },
      {
        internalType: 'string',
        name: '_uri',
        type: 'string',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'createById',
    outputs: [
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'creators',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'isMinter',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'isWhitelistAdmin',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
    ],
    name: 'maxSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_quantity',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'operators',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'removeMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'removeWhitelistAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceMinter',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceWhitelistAdmin',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'tokenMaxSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'tokenSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
    ],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'transferLocked',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_id',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_quantity',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'mintOwnable',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'string',
        name: 'uri',
        type: 'string',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'createAndMint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'status',
        type: 'bool',
      },
    ],
    name: 'setOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]',
      },
      {
        internalType: 'bool',
        name: 'status',
        type: 'bool',
      },
    ],
    name: 'setLockTransfer',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]

const _bytecode =
  '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'

export class RoseCollection__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0])
    } else {
      super(...args)
    }
  }

  deploy(
    _name: string,
    _symbol: string,
    _url: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<RoseCollection> {
    return super.deploy(
      _name,
      _symbol,
      _url,
      overrides || {}
    ) as Promise<RoseCollection>
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _url: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_name, _symbol, _url, overrides || {})
  }
  attach(address: string): RoseCollection {
    return super.attach(address) as RoseCollection
  }
  connect(signer: Signer): RoseCollection__factory {
    return super.connect(signer) as RoseCollection__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): RoseCollectionInterface {
    return new utils.Interface(_abi) as RoseCollectionInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): RoseCollection {
    return new Contract(address, _abi, signerOrProvider) as RoseCollection
  }
}
